// eslint-disable-next-line no-restricted-imports
import { LDFlagSet } from '@joor/launchdarkly-react-client-sdk'

import { ICtaBannerItem, ICtaBannerItemFields } from '__generated__/contentful'

import { toCamelCase } from './toCamelCase'

export const getBannerItemToShow = (
  items: ICtaBannerItem[],
  flags: LDFlagSet,
) => {
  let ctaBannerItemFields: ICtaBannerItemFields | null = null
  const publicBannersFields: ICtaBannerItemFields[] = []
  const segmentedBannersFields: ICtaBannerItemFields[] = []

  items.forEach((item) => {
    if (!item.fields.featureFlag) {
      publicBannersFields.push(item.fields)
    } else if (flags[toCamelCase(item.fields.featureFlag)]) {
      segmentedBannersFields.push(item.fields)
    }
  })
  // We prioritize the segmented one
  if (segmentedBannersFields.length) {
    ctaBannerItemFields = segmentedBannersFields[0]
  } else if (publicBannersFields.length) {
    ctaBannerItemFields = publicBannersFields[0]
  }

  return ctaBannerItemFields
}
